import {
  findNearestSnapPoint,
  type SnapPoint,
} from "../../vendor/src/features/remotion-editor/editor/timeline/utils/snap-points";
export function snapMoveEdges(
  from: number,
  duration: number,
  points: SnapPoint[],
  threshold: number,
): { from: number; point: SnapPoint | null } {
  const start = findNearestSnapPoint({
    targetFrame: from,
    snapPoints: points,
    thresholdInFrames: threshold,
  });
  const end = findNearestSnapPoint({
    targetFrame: from + duration,
    snapPoints: points,
    thresholdInFrames: threshold,
  });
  if (
    end &&
    end.frame >= duration &&
    (!start ||
      Math.abs(end.frame - from - duration) < Math.abs(start.frame - from))
  )
    return { from: end.frame - duration, point: end };
  return start ? { from: start.frame, point: start } : { from, point: null };
}
